// Initialize tab-switching for dynamically added elements
$(document).on("click", ".tbslinks", function (e) {
  e.preventDefault();
  $(".tbscontent").removeClass("show");
  $(".tbslinks").removeClass("active");

  const $target = $($(this).data("target"));
  if (!$target.length) {
    return;
  }
  $target.addClass("show");
  $(this).addClass("active");
});

// Truncate HTML content with word limit
function truncateHTMLContent(selector = '.product-info__block-item.app-description', wordLimit = 37) {
  const $elements = $(selector);
  if (!$elements.length) {
    return;
  }

  $elements.each(function () {
    const $el = $(this);
    if ($el.data('truncated') || !$el.html().trim()) return;

    const fullHtml = $el.html().trim();
    const tempDiv = $("<div>").html(fullHtml);
    let wordCount = 0;
    let visibleHtml = "", hiddenHtml = "";

    const processNode = (node) => {
      if (wordCount >= wordLimit) {
        hiddenHtml += node.outerHTML || node.textContent;
        return;
      }

      if (node.nodeType === 3) {
        const words = node.textContent.trim().split(/\s+/);
        if (!words.length) return;

        if (wordCount + words.length <= wordLimit) {
          visibleHtml += node.textContent;
          wordCount += words.length;
        } else {
          const cut = wordLimit - wordCount;
          visibleHtml += words.slice(0, cut).join(" ") + " ";
          hiddenHtml += words.slice(cut).join(" ") + " ";
          wordCount = wordLimit;
        }
      } else if (node.nodeType === 1) {
        const tag = node.tagName.toLowerCase();
        const attrs = [...node.attributes].map(a => ` ${a.name}="${a.value}"`).join("");
        const open = `<${tag}${attrs}>`, close = `</${tag}>`;

        let childVisible = "", childHidden = "";
        const prevVis = visibleHtml, prevHid = hiddenHtml;
        visibleHtml = ""; hiddenHtml = "";
        $(node).contents().each(function () {
          processNode(this);
          childVisible += visibleHtml;
          childHidden += hiddenHtml;
          visibleHtml = prevVis;
          hiddenHtml = prevHid;
        });

        if (childVisible) visibleHtml += open + childVisible + close;
        if (childHidden) hiddenHtml += open + childHidden + close;
      }
    };

    tempDiv.contents().each(function () {
      processNode(this);
    });

    if (wordCount >= wordLimit) {
      $el.html(`
        ${visibleHtml}<span class="dots">...</span>
        <span class="more-text" style="display:none;">${hiddenHtml}</span>
        <a href="#" class="read-more-toggle" style="cursor:pointer;"> Read more</a>
      `);
      $el.data('truncated', true);
    }
  });
}

// Global toggle handler for "Read more"/"Read less"
$(document).on("click", ".read-more-toggle", function (e) {
  e.preventDefault();
  const $t = $(this);
  const $p = $t.closest(".product-info__block-item");
  if (!$p.length) {
    console.error('Parent element not found for toggle:', $t);
    return;
  }
  const $moreText = $p.find(".more-text");
  const $dots = $p.find(".dots");
  if (!$moreText.length || !$dots.length) {
    console.error('More text or dots not found in:', $p);
    return;
  }
  $moreText.toggle(200);
  $dots.toggle(200);
  $t.text($t.text().trim() === "Read more" ? " Read less" : " Read more");
});

// Map variant IDs or body classes to word limits
function getWordLimitForVariant() {
  const wordLimits = {
    'hair': 33,
    'magnesium': 32,
    'skin': 27,
    'lean': 22,
    'skin-combo': 20,
    'calm-clarity': 21,
    'bundle': 19,
    'detox': 22,
    'new-variant': 25 // Placeholder for new variant
  };

  // Check URL for variant ID (e.g., ?variant=123)
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant') || '';
  console.log('Detected variant ID from URL:', variantId); // Debug

  // Map variant IDs to keys (customize this mapping)
  const variantMap = {
    'variant123': 'hair', // Replace with actual variant IDs
    'variant456': 'magnesium',
    'variant789': 'skin',
    'variant-new': 'new-variant' // Replace with your new variant ID
  };

  const variantKey = variantMap[variantId] || '';
  if (variantKey && wordLimits[variantKey]) {
    return wordLimits[variantKey];
  }

  // Fallback to body classes
  const bodyClasses = $('body').attr('class') || '';
  for (const [className, limit] of Object.entries({
    'product-new-template-hair': 33,
    'product-new-template-magnesium': 32,
    'product-new-template-skin': 27,
    'product-new-template-lean': 22,
    'product-new-template-skin-combo': 20,
    'product-new-template-calm-clarity': 21,
    'product-new-template-bundle': 19,
    'product-new-template-detox': 22,
    'product-new-template-new-variant': 25
  })) {
    if (bodyClasses.includes(className)) return limit;
  }

  return 37; // Default
}

// Reset truncation state
function resetTruncation(selector) {
  $(selector).removeData('truncated');
}

// Initialize on page load
$(document).ready(function () {
  console.log('Initializing on page load'); // Debug
  const wordLimit = getWordLimitForVariant();
  truncateHTMLContent('.product-info__block-item.app-description', wordLimit);

  // Initialize first tab as active
  if ($(".tbslinks").length) {
    $(".tbslinks").first().trigger('click');
  }
});

function updateForcefulDiscountedPrice() {
  const $offer = $('#dynamic-offer');
  if (!$offer.length) return;

  // Try to get variant price from data attribute
  let initialPrice = parseFloat($offer.data('initial-price'));

  // If no variant price, fall back to original product price
  if (!initialPrice || initialPrice <= 0) {
    const $ogPrice = $('.ogprice');
    initialPrice = $ogPrice.length
      ? parseFloat($ogPrice.text().replace(/[^0-9.]/g, ''))
      : 0;
  }

  let discountPercent = parseFloat($offer.data('discount')) || 0;

  let discountedPrice = initialPrice * (100 - discountPercent) / 100;

  // Forcefully remove decimals
  let forcefulPrice = discountedPrice.toString().split('.')[0];

  // Update display and data attribute
  $offer.find('.dosconut-prize').text(forcefulPrice);
  $offer.data('discounted-price', forcefulPrice);
}

updateForcefulDiscountedPrice();
function setupCopyToClipboard() {
    document.querySelectorAll('.copy-code-wrap').forEach(function(copyWrap) {
        copyWrap.addEventListener('click', function () {
            const code = this.querySelector('.code-offer').innerText.trim();
            navigator.clipboard.writeText(code).then(() => {
                const tooltip = this.querySelector('.copy-tooltip');
                tooltip.style.opacity = '1'; 
                setTimeout(() => tooltip.style.opacity = '0', 1500); 
            });
        });
    });
}
  setupCopyToClipboard();
// Handle dynamic variant changes (via selector or URL change)
$(document).on('change', '#variant-selector', function () {
  console.log('Variant selector changed:', $(this).val()); // Debug
  setupCopyToClipboard();
  // Re-initialize tabs
  if ($(".tbslinks").length) {
    $(".tbslinks").first().trigger('click');
  }
  setupCopyToClipboard();
});

// Detect URL changes (for single-page apps)
let lastUrl = window.location.href;
function checkUrlChange() {
  const currentUrl = window.location.href;
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl;
    setupCopyToClipboard();
    // Re-initialize tabs
    if ($(".tbslinks").length) {
      $(".tbslinks").first().trigger('click');
    }
  }
}

// Poll for URL changes
setInterval(checkUrlChange, 100);

// Listen for history API changes
window.addEventListener('popstate', function () {
  console.log('History state changed'); // Debug
  checkUrlChange();
});